import styled from "styled-components";
import colors from "assets/scss/colors.scss";

const VehicleDetailsWrapper = styled.div`
  
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  text-align: initial;
  margin-top: 50px;
  .card-option {
    marfin-bottom: 1rem;
    min-width: 48%;
  }

  .p-float-label input:-webkit-autofill ~ label{
    top: -0.75rem;
  }
  .p-float-label input:focus ~ label, .p-float-label input.p-filled ~ label, .p-float-label textarea:focus ~ label, .p-float-label textarea.p-filled ~ label, .p-float-label .p-inputwrapper-focus ~ label, .p-float-label .p-inputwrapper-filled ~ label {
    top: 0.7rem ;
    font-size: 12px;
    font-weight: 400;
    color: #818B9B;
    right: 70px ;
  }


  .newclassMobileFix{
    margin-bottom: 100px;
  }
  .p-inputtext,.p-inputnumber {
    font-size: 0.9rem;
    background: #FFFFFF;
    box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
    border-radius: 4px;
  }
  .p-inputgroup-addon{
    background: #F2F3F5;
    box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
    border-radius: 4px;
  }
  .field {
    input,
    .p-dropdown {
      box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
      border: none;
    }
  }
  .vehicle-icon {
    margin-top:-12px;
  }
  .header {
    color: #4c565c;
    display: flex;
    justify-content: space-between;
    & > h5 {
          color: #1a1c1f;           
  font-weight: 800;
      font-size: 1.1rem;
    }
    & > p {
      font-size: 0.9rem;
      color: #4c565c;
    }
    & > button {
      width: fit-content;
      background: transparent;
      font-family: "tawuniya";
      color: ${props => props.businessColor};
      border: none;
      font-size:0.8rem;
      box-shadow: none;
      outline: none;
      &.p-button-label {
        font-weight: normal;
      }
      &:hover {
        background: transparent;
        color: ${props => props.businessColor};
        border: none;
      }
    }
  }


  & > form {
    .item {
      padding: 20px;
      background: #f2f3f5;
      border-radius: 5px;
      margin-bottom: 20px;
    }

    .p-datatable{
      .p-dropdown,.p-inputtext{
        border:none;
      }


      .p-datatable-tbody > tr{
        border-bottom: 1px solid rgba(38, 38, 38, 0.1);
      }

      .p-datatable .p-column-header-content{
        justify-content:center;
        font-size:16px;
        font-family:'tawuniya';
        color:#4C565C;
      }

      .p-datatable-tbody > tr > td{
        padding:0.5rem;
        border:none;
        & > * {
          border-right: 1px solid rgba(38, 38, 38, 0.1);
          border-radius:0;
        }
      }
    }

    .actions{
      display:flex;
      justify-content:center;
      margin: 40px 0 0 0;
      button{
        border-radius: 8px;
        padding:5px 10px;
        width:10rem;
        &.save-btn{
          background: ${colors["bright-purple"]};
          color:white;
        }
        &.cancel-btn{
          background:white;
          border: ${props => `1px solid ${props.businessColor}`};
          color: ${props => props.businessColor};
          margin: 0 10px;
        }
      }
    }

    .table-delete-btn {
      color: #c4314b;
      border: none;
      background: #fcf4f6;
      height: 0 !important;
      padding: 1rem;
      width: 0  !important;
      box-shadow:none;
      outline:none;
      &:hover{
        background: #fcf4f6  !important;
        color: #c4314b !important;
        border: none !important;
      }
    }
  }

  .p-calendar {
    .p-button-icon-only {
      background: white;
      outline: none;
      box-shadow: none;
      border: none;
    }
  }
  .add-vehicle {
    width: fit-content;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    font-size:0.8rem;
    // margin:10px 0;
    border: none;
    background: ${colors["bright-purple"]};
    border-radius: 8px;
    outline: none;
    box-shadow: none;
    .pi-plus{
      margin-inline-end:0.5rem !important;
    }
    .p-button-icon {
      background: transparent;
    }
    &:hover {
      background: ${colors["bright-purple"]};
      color: white;
    }
  }

  .phone-input {
    .keys {
      width: 25%;
      border-radius: 5px 0 0 5px;
      background: #f2f3f5;
      .p-dropdown-trigger-icon {
        font-size:0.75rem;
            color: #1a1c1f;           
  font-weight: 800;
      }
    }
    .values {
      width: 85%;
      border-radius: 0 5px 5px 0;
    }
  }



  .vehicle-item{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    background: #F2F3F5;
    border-radius: 8px;
    width:100%;
    margin: 1rem 0;
    &.missing{
      border: 1px solid #C4314B;
    }

    .vehicle-img{
      border-right:1px solid rgba(26, 28, 31,0.1);
      width:12%;
      padding:0;
    }
    .vehicle-details{
      width: 100%;
      display: flex;
      justify-content: space-between;
    align-items: center;
      .details{
        .title{
          font-size:0.75rem;
          color: #676F7C;
        }
      }
        .plate{
          // background:url();
          // background-size: 40%;
          // background-repeat: no-repeat;
          // background-position: right;
          // background-origin: content-box;
          .plate-wrapper{
            width: 100%;
            max-width: 130px;
            position: relative;
            img{
              width: 100%
            }
            .numbers{
              position: absolute;
              left: 10%;
              &.en{
                top:22px;
              }
              &.ar{
                top:1px;
              }
            }
            .chars{
              position: absolute;
              right: 25%;
              &.ar{
                top:1px;
              }
              &.en{
                top:22px;
              }
            }
          }
          & > *{
            float: right;
            position: relative;
            font-size:0.8rem;
                color: #1a1c1f;           
  font-weight: 800;
            top: 5%;
            &.chars{
              // right: 0;
              // left: 5%;
            }
            &.numbers{
              right: 27%;
            }
          }

        }
      }
    }

    .vehicle-actions{
      border-left:1px solid rgba(26, 28, 31,0.1);
      width:12%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      margin-left: 10px;
      padding: 0;
      button{
        border:none;
        outline:none;
        box-shadow:none;
        padding:6px;
        margin:0 5px;
        &.edit{
          background: #E3FFEF;
        }
        &.remove{
          background: #FCF4F6;
        }
        &:hover{
          border:none !important;
          outline:none  !important;
          box-shadow:none  !important;
        }
      }
      
    }

    form{
      .actions{
        margin-bottom: 2rem;
        justify-content: flex-start;
        button{
          display: flex;
          flex-direction: row;
          gap: 1rem;
          justify-content: flex-start;
          align-items: center;
          // padding: 0px 16px 0px 24px;
          padding:6px 20px;
          width: fit-content;
          outline:none;
          box-shadow:none;
          border-radius: 5px;
          border:none;
      
          &.save-btn{
            background: ${colors["bright-purple"]};
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0.5rem 2rem;
            color:#FFF;
            margin:0 10px;
            svg{
              width: 20px;
              height: 20px;
              margin: 0 5px;
            }
          }
          &.close-btn{
            border:none;
            color:#4C565C;
            margin:0 10px;
            &:hover,&:focus,&:active{
              background:transparent;
              border:none;
              color:#4C565C;
            }
          }
        }
      }
    }
  }

  .preview_wrapper{
    //margin-top: 0rem;
    .missing_data{
      position: relative;
      display: inline-block;
      background: #C4314B;
      padding: 8px 18px;
      margin: 0 1rem 0 auto;
      float: right;
      font-family: tawuniya;
      font-size:0.75rem;
      font-weight: 800;
      line-height: 12px;
      letter-spacing: 0em;
      text-align: center;
      color: #fff;
      border-radius: 12px 6px 0px 0px;
      &::after{
        content: '';
        position: absolute;
        left: 42%;
        top: 100%;
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid #C4314B;
        clear: both;
    }
    }
  }
  .yomLabel{
    position: absolute;
    top: -1.5rem;
    left: 0.75rem;
    font-size: 0.75rem;
    color:#6c757d;
  }

  .question_mark {
    position: absolute;
    right: 0.75rem;
    cursor: pointer;
  }
  
  @media only screen and (min-width: 993px){
    .card-option {
      width: 49%;
    }
  }
  @media only screen and (max-width: 568px){
    .save_wrapper .save-btn{
      margin-bottom: 5rem;
    }
    .vehicle-item .vehicle-img{
      width: 100%;
      display: inline-flex;
      justify-content: center;
      margin-bottom: 1rem;
      border: none;
    }
    .card__wrapper{
      justify-content: center;
      flex-direction: column;
      align-items: center;
      width: 100%;
      display: flex;
      padding: 0;
    }
    .vehicle-details{
      width: 100% !important;
      display: inline-flex;
      justify-content: space-between;
      svg{
        max-width: 50px;
      }
      .details{
        font-size: 0.6rem;
        margin-inline-start: 10px;
      }
    }
    .plate{
      padding: 0;
      margin-inline-end: 5px;
    }
    .plate-wrapper{
      img{
        height: 40px;
      }
    }
  }

  &.ar{
    p{
      font-family: "tawuniya";
    }
    input.p-inputtext.p-component::placeholder {
      font-family: "tawuniya";
    }
    .pi {font-family: 'primeicons'!important;}
    .p-input-icon-left > .p-inputtext{
      padding-right: 3.5rem;
    }
    .p-input-icon-left > svg:first-of-type {
      top: 1.2rem;
      right: 1rem;
      left: auto;
    }
    .question_mark {
      left: 0.75rem;
      right: auto;
      transform: scaleX(-1);
    }
  }
`;

export default VehicleDetailsWrapper;
